import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=7b57a9e2&scoped=true"
var script = {}
import style0 from "./Contact.vue?vue&type=style&index=0&id=7b57a9e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b57a9e2",
  null
  
)

export default component.exports